export default {
  title: 'Merchant Management',
  companyInfo: 'Company Info',
  emailConfig: 'Email Config',
  smsConfig: 'SMS Config',
  i18nManagement: 'I18n Management',
  paymentAuthConfig: 'Payment & Auth Config',
  systemSettings: 'System Settings',
  roleManagement: 'Role Management',
  accountManagement: 'Account Management',
  operationLog: 'Operation Log',
  companyName: 'Company Name',
  companyNameReadonly: 'Company Info',
  companyNameReadonlyTip: 'Enter the company display name in this language',
  companyLogo: 'Company Logo',
  companyLogoTip:
    'Supports JPG, PNG format, max 5MB. Thumbnail preview and replaceable after upload',
  companyLocaleLabel: 'Company Profile',
  companyEmail: 'Company Email',
  companyEmailPlaceholder: 'Please enter company email',
  companyPhone: 'Company Phone',
  companyPhonePlaceholder: 'Please enter contact phone',
  companyAddress: 'Company Address',
  companyAddressPlaceholder: 'Please enter company address',
  companyIntro: 'Company Introduction',
  companyIntroPlaceholder: 'Please enter company introduction',
  save: 'Save',
  saveSuccess: 'Saved successfully',
  uploadSuccess: 'Upload successful',
  uploadFail: 'Upload failed',
  logoFormatError: 'Only JPG and PNG formats are supported',
  logoSizeError: 'Image size cannot exceed 5MB',
  locale_zh_TW: '繁體中文',
  locale_zh_CN: '简体中文',
  locale_en_US: 'English',
  locale_ja_JP: 'Japanese',
};
